import { z } from 'zod';

export const listAuditQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  perPage: z.coerce.number().int().positive().max(100).default(50),
  action: z.string().min(1).max(64).optional(),
  resourceType: z.string().min(1).max(32).optional(),
  // Post IDs are 13-digit numeric strings; user/role IDs are UUIDs;
  // media uses UUID; etc. Keep loose — any non-empty string up to 64.
  resourceId: z.string().min(1).max(64).optional(),
  userId: z.string().uuid().optional(),
  // ISO-ish date-time strings (Date constructor accepts everything
  // <input type="datetime-local"> emits + full ISO 8601). The handler
  // validates parse-ability before applying — invalid values are
  // dropped rather than 400'd so a typo doesn't shut out the rest
  // of the filter chain. Inclusive on `from`, exclusive on `to`.
  from: z.string().min(1).max(64).optional(),
  to: z.string().min(1).max(64).optional(),
});

export type ListAuditQuery = z.infer<typeof listAuditQuerySchema>;
